export const styles = theme => ({
    root: {
        justifyContent: "space-between",
        margin: "2rem auto",
        display: "flex",
        maxWidth: 1200,
    },

    logo: {
        marginLeft: "1rem",
    },

    rightSide: {
        display: "flex",
        "& ul": {
            listStyleType: "none",
            padding: 0,
        },
        "& li": {
            display: "inline-block",
            margin: "0 .5rem",
        },
    },
    link: {
        textDecoration: "none",
        color: "#333",
        fontSize: ".875rem",
        "&:hover": {
            textDecoration: "underline",
            color: "#009",
        },
        cursor: "pointer"
    }
});
